import React, { Component } from 'react';
import {
    Container,
    Col,
    Row,
    Table,
    Button,
    Form,
    Input
} from 'reactstrap';
import { withRouter } from 'react-router-dom';

export class FattureScaduteContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: "FATTURE SCADUTE",
            fatture: [],
            totalFatture: 0,
            numPerPage: 5,
            changeNumPerPage: 0,
            pageNum: 1,
            searchText: "",
            ordinamento: "fatturaId",
        };
    }

    componentDidMount = () => {
        this.getFatture();
        console.log(this.state.fatture);
    }

    getFatture = () => {
        const form = {
            searchText: this.state.searchText,
            numPerPage: this.state.numPerPage,
            pageNum: this.state.pageNum,
            ordinamento: this.state.ordinamento
        }

        fetch(`/api/getFattureScadute`, {
            method: 'POST',
            headers: new Headers({
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(form)
        }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    fatture: myjson.fatture,
                    totalFatture: myjson.totalFatture,
                    totalPages: myjson.totalPages,
                    numPerPage: myjson.totalFatture < this.state.numPerPage ? myjson.totalFatture : this.state.numPerPage
                })
            }).catch(e => {
                console.log(e);
            });
    }

    handleButtonChangeNumPerPage = (num) => {
        const newNumPerPage = ((this.state.numPerPage + num) > 0) && ((this.state.numPerPage + num) <= this.state.totalFatture) ? (this.state.numPerPage + num) : this.state.numPerPage;

        if (newNumPerPage !== this.state.numPerPage) {
            this.setState({
                numPerPage: newNumPerPage,
                pageNum: newNumPerPage >= this.state.totalFatture && this.state.pageNum !== 1 ? this.state.pageNum - 1 : this.state.pageNum
            }, () => this.getFatture());
        }
        else if (this.state.numPerPage > this.state.totalFatture) {
            if (num < 0) {
                this.setState({
                    numPerPage: this.state.numPerPage + num,
                });
            }

        }
    }

    handleInputChangeNumPerPage = (e) => {
        e.preventDefault(e);

        const isNum = /^\d+$/.test(e.target.value);

        if (isNum) {
            this.setState({
                numPerPage: parseInt(e.target.value, 10)
            });
        }
        else if (e.target.value === '') {
            this.setState({
                numPerPage: e.target.value,
            })
        }
    }

    handleNumPerPageSubmit = (e) => {
        e.preventDefault();

        if (this.state.numPerPage >= this.state.totalFatture) {
            this.setState({
                pageNum: 1,
                numPerPage: this.state.totalOrdini
            }, () => this.getFatture())
        }
        else {
            this.setState({
                pageNum: 1,
            }, () => this.getFatture())
        }
    }    

    handlePrev = (e) => {
        this.setState({
            pageNum: this.state.pageNum - 1
        }, () => this.getFatture());
    }

    handleNext = (e) => {
        this.setState({
            pageNum: this.state.pageNum + 1
        }, () => this.getFatture());
    }

    handleOrdinamento = (ord) => {
        this.setState({
            ordinamento: ord,
            pageNum: 1
        }, () => this.getFatture());
    }

    render() {
        const fatture = this.state.fatture;

        const titolo = (
            <Container className="d-flex align-items-center justify-content-center" style={{ paddingBottom: "15px" }} fluid>
                <Row className="d-flex" style={{ margin: "0px", width: "100%" }}>
                    <Col xs={{ size: 12, order: 2 }} md={{ size: 3, order: 1 }} className="d-flex align-items-center justify-content-md-start justify-content-center pl-md-0 mb-2 mb-md-0" >
                        <Form className="form" onSubmit={this.handleNumPerPageSubmit}>
                            <Row className="d-flex align-items-center" >
                                <Col className=" d-flex justify-content-end col-4" style={{ padding: "0px", marginRight: "0px", height: "40px" }}>
                                    <Button onClick={() => this.handleButtonChangeNumPerPage(-1)} style={{ height: "100%", width: "100%", padding: "0px", borderTopLeftRadius: "25px", borderWidth: "medium", borderBottomLeftRadius: "25px", borderTopRightRadius: "0px", borderBottomRightRadius: "0px", color: "#011e41", borderColor: "#011e41", backgroundColor: "transparent", borderRight: "0px", fontSize: "25px", verticalAlign: "middle", textAlign: "center", fontWeight: "bold" }}>-</Button>
                                </Col>
                                <Col className="d-flex justify-content-center col-4" style={{ padding: "0px", marginLeft: "0px", marginRight: "0px", height: "40px" }}>
                                    {this.state.totalOrdini === 0 ?
                                        <Input id="numPerPage" name="numPerPage" type="text" className="form-control" value={this.state.numPerPage} onChange={this.handleInputChangeNumPerPage} style={{ width: "100%", height: "100%", padding: "0px", borderWidth: "medium", borderRadius: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41" }} /> :
                                        <Input id="numPerPage" name="numPerPage" type="text" className="form-control" value={this.state.numPerPage} onChange={this.handleInputChangeNumPerPage} style={{ width: "100%", height: "100%", padding: "0px", borderWidth: "medium", borderRadius: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41" }} />}
                                </Col>
                                <Col className=" d-flex justify-content-start col-4" style={{ padding: "0px", marginRight: "0px", height: "40px" }}>
                                    <Button onClick={() => this.handleButtonChangeNumPerPage(1)} style={{ height: "100%", width: "100%", padding: "0px", borderWidth: "medium", borderTopRightRadius: "25px", borderBottomRightRadius: "25px", borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px", color: "#011e41", borderColor: "#011e41", backgroundColor: "transparent", borderLeft: "0px", fontSize: "25px", verticalAlign: "middle", textAlign: "center", fontWeight: "bold" }}>+</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Container>
        );

        const navFooter = (
            <Container className="d-flex align-items-center justify-content-center" style={{ padding: "0px", paddingBottom: "15px" }} fluid>
                <Row style={{ margin: "0px", width: "100%" }}>
                    <Col className="d-flex align-items-center justify-content-start col-6" style={{ paddingLeft: "0px", color: "#011e41" }}>
                        {this.state.totalFatture !== 0 ? "Mostra da " + ((this.state.numPerPage * (this.state.pageNum - 1)) + 1) + " a " + (this.state.numPerPage * this.state.pageNum <= this.state.totalFatture ? this.state.numPerPage * this.state.pageNum : this.state.totalFatture) + " di " + this.state.totalFatture + " risultati" : null}
                    </Col>
                    <Col className="d-flex align-items-center justify-content-end col-6" style={{ paddingLeft: "0px", color: "#011e41" }}>
                        {this.state.pageNum === 1 ? null : <a style={{ paddingRight: "10px", cursor: "pointer" }} onClick={this.handlePrev}>Indietro</a>}
                        {(this.state.pageNum === 1 && this.state.pageNum === this.state.totalFatture) || this.state.totalFatture === 0 ? null : this.state.pageNum}
                        {(this.state.pageNum === this.state.totalPages) || this.state.totalFatture === 0 ? <p style={{ paddingLeft: "35px" }}></p> : <a style={{ paddingLeft: "10px", cursor: "pointer" }} onClick={this.handleNext}>Avanti</a>}
                    </Col>
                </Row>
            </Container>
        );

        return (
            <div style={{ width: "100%" }}>
                <h2 style={{ textAlign: 'center', color: 'black' }}>{this.state.title}</h2>
                {titolo}
                <Container className="d-flex align-items-center" fluid>                    
                    <Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
                        <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
                            <Table responsive borderless>
                                <thead>
                                    <tr style={{ borderBottom: "1px solid #011e41" }}>
                                        <th style={{ padding: "0", textAlign: "center" }}>Numero Documento
                                            <Button onClick={() => this.handleOrdinamento("NumeroDocumento")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-up"></i></Button>
                                            <Button onClick={() => this.handleOrdinamento("NumeroDocumentoD")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-down"></i></Button>
                                        </th>
                                        <th style={{ padding: "0", textAlign: "center" }}>Data Fattura
                                            <Button onClick={() => this.handleOrdinamento("dataFattura")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-up"></i></Button>
                                            <Button onClick={() => this.handleOrdinamento("dataFatturaD")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-down"></i></Button>
                                        </th>
                                        <th style={{ padding: "0", textAlign: "center" }}>Cliente
                                            <Button onClick={() => this.handleOrdinamento("cliente")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-up"></i></Button>
                                            <Button onClick={() => this.handleOrdinamento("clienteD")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-down"></i></Button>
                                        </th>
                                        <th style={{ padding: "0", textAlign: "center" }}>P.IVA
                                            <Button onClick={() => this.handleOrdinamento("PIVA")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-up"></i></Button>
                                            <Button onClick={() => this.handleOrdinamento("PIVAD")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-down"></i></Button>
                                        </th>
                                        <th style={{ padding: "0", textAlign: "center" }}>Scaduta il
                                            <Button onClick={() => this.handleOrdinamento("scadutaIl")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-up"></i></Button>
                                            <Button onClick={() => this.handleOrdinamento("scadutaIlD")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-down"></i></Button>
                                        </th>
                                        <th style={{ padding: "0", textAlign: "center" }}>Importo
                                            <Button onClick={() => this.handleOrdinamento("importo")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-up"></i></Button>
                                            <Button onClick={() => this.handleOrdinamento("importoD")} style={{
                                                width: "10%",
                                                padding: "0px",
                                                color: "#011e41",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                marginLeft: "5px",
                                                marginRight: "10px"
                                            }}><i class="fa fa-arrow-down"></i></Button>
                                        </th>
                                    </tr>
                                </thead>
                                {/*<tbody>*/}
                                    {/*{*/}
                                    {/*    this.state.fatture.map((b, index) => {*/}
                                    {/*        console.log(b);*/}
                                    {/*        var ScadenzaString = b.scadenza.substring(0, 10);*/}
                                    {/*        return (*/}
                                    {/*            <tr key={index} >*/}
                                    {/*                <td align="center" style={{ padding: "0" }}>{b.fatturaId}</td>*/}
                                    {/*                <td align="center" style={{ padding: "0" }}>{b.ragSoc} { b.insegnaEsterna }</td>*/}
                                    {/*                <td align="center" style={{ padding: "0" }}>{b.piva}</td>*/}
                                    {/*                <td align="center" style={{ padding: "0" }}>{ScadenzaString}</td>*/}
                                    {/*                <td align="center" style={{ padding: "0" }}>€ {b.importo}</td>*/}
                                    {/*            </tr>*/}
                                    {/*        )*/}
                                    {/*    })*/}
                                    {/*}*/}

                                {this.state.fatture && this.state.fatture.length > 0 ? (
                                    <tbody>
                                        {this.state.fatture.map((b, index) => {
                                            console.log(b);
                                            //var ScadenzaString = b.scadenza.substring(0, 10);
                                            //Data Scadenza
                                            const DataScadenza = new Date(b.scadenza);
                                            const ggScadenza = String(DataScadenza.getDate()).padStart(2, '0');
                                            const mmScadenza = String(DataScadenza.getMonth() + 1).padStart(2, '0');
                                            const yyyyScadenza = DataScadenza.getFullYear();
                                            var ScadenzaString = `${ggScadenza}/${mmScadenza}/${yyyyScadenza}`;

                                            //Data Fattura
                                            const DataFattura = new Date(b.dataFattura);
                                            const ggFattura = String(DataFattura.getDate()).padStart(2, '0');
                                            const mmFattura = String(DataFattura.getMonth() + 1).padStart(2, '0');
                                            const yyyyFattura = DataFattura.getFullYear();
                                            var FatturaString = `${ggFattura}/${mmFattura}/${yyyyFattura}`;

                                            var PIVA_CF = b.piva == "" || b.piva == null ? b.codFisc : b.piva;

                                            return (
                                                <tr key={index}>
                                                    <td align="center" style={{ padding: "0" }}>{b.numeroDocumento}</td>
                                                    <td align="center" style={{ padding: "0" }}>{FatturaString}</td>
                                                    <td align="center" style={{ padding: "0" }}>{b.ragioneSociale}</td>
                                                    <td align="center" style={{ padding: "0" }}>{PIVA_CF}</td>
                                                    <td align="center" style={{ padding: "0" }}>{ScadenzaString}</td>
                                                    <td align="center" style={{ padding: "0" }}>€ {b.importo}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                ) : (
                                    <tbody>
                                        <tr>
                                            <td colSpan="5" align="center">Nessuna fattura scaduta trovata.</td>
                                        </tr>
                                    </tbody>
                                )}
                                {/*</tbody>*/}
                            </Table>
                        </Col>
                    </Row>                   
                </Container>
                {navFooter}
            </div>            
        )
    }
}
export default withRouter(FattureScaduteContainer)


// WEBPACK FOOTER //
// ./src/containers/FattureScaduteContainer.js